import axios from 'axios';

export default {
    authenticate(params) {
        return axios.post(auth_url, params);
    }
};



// WEBPACK FOOTER //
// ./src/api/authentication.js